import { NgModule } from '@angular/core';
import { CourseAnalyticsComponent } from '@app/main/analytics/course/course-analytics.component';
import { SharedModule } from '@shared/shared.module';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { RouterModule } from '@angular/router';
import { AnalyticsRoutingModule } from '@app/main/analytics/analytics-routing.module';
import { SessionListComponent } from '@app/main/analytics/session-list/session-list.component';
import { XAPILogComponent } from '@app/main/analytics/xapi-log/xapi-log.component';
import { QuizChartComponent } from '@app/main/analytics/misc/quiz-chart';
import { PageHeaderComponent } from '@app/main/analytics/page-header/page-header.component';
import { EmbedDialogModule } from '@shared/components/embed-dialog/embed-dialog.module';
import { CourseStatsComponent } from '@app/main/analytics/course-stats/course-stats.component';
import { LearnspaceAnalyticsComponent } from '@app/main/analytics/learnspace/learnspace-analytics.component';
import { ExperienceCardComponent } from '@app/main/analytics/learnspace/experience-card/experience-card.component';
import { ContentStatComponent } from '@app/main/analytics/content-stats/content-stats.component';
import { AnalyticsLoaderModule } from '@app/main/analytics/loader-directive/loader.module';
import { PeriodPickerComponent } from './period-picker/period-picker/period-picker.component';
import { ContentsStatItem } from '@app/main/analytics/content-stats/contents-stat-item/contents-stat-item.component';
import { AnnotationsStatComponent } from '@app/main/analytics/annotations-stats/annotations-stats.component';
import { AnnotationStatItemComponent } from './annotations-stats/annotation-stat-item/annotation-stat-item.component';
import { QuizResultsComponent } from './quiz-results/quiz-results.component';
import { GaugeModule } from 'angular-gauge';
import { VisitorsStatsComponent } from './visitors-stats/visitors-stats.component';
import { LatestSessionsWidgetComponent } from './misc/latest-sessions-widget';
import { HubStatComponent  } from './hub-stats/hub-stats.component';
import { StatCardComponent } from './misc/stat-card/stat-card.component';
import { HubExperienceCardComponent } from './hub-stats/hub-experience-card/hub-experience-card.component';
import { HubOverviewComponent } from './hub-stats/hub-overview/hub-overview.component';
import { HubUsageComponent } from './hub-stats/hub-usage/hub-usage.component';
import { GoogleChartLegendComponent } from './misc/google-chart-legend';
import { ExperienceMenuComponent } from './misc/experience-menu';
import { AssessmentModule } from './assessment/assessment.module';
import { UserSearchModule } from '@shared/components/user-search/user-search.module';

@NgModule({
    declarations: [
        CourseAnalyticsComponent,
        SessionListComponent,
        XAPILogComponent,
        QuizChartComponent,
        PageHeaderComponent,
        CourseStatsComponent,
        LearnspaceAnalyticsComponent,
        ExperienceCardComponent,
        ContentStatComponent,
        PeriodPickerComponent,
        ContentsStatItem,
        AnnotationsStatComponent,
        AnnotationStatItemComponent,
        QuizResultsComponent,
        VisitorsStatsComponent,
        LatestSessionsWidgetComponent,
        HubStatComponent,
        StatCardComponent,
        HubExperienceCardComponent,
        HubUsageComponent,
        HubOverviewComponent,
        GoogleChartLegendComponent,
        ExperienceMenuComponent,
    ],
    imports: [
        SharedModule,
        Ng2GoogleChartsModule,
        RouterModule,
        AnalyticsRoutingModule,
        EmbedDialogModule,
        AnalyticsLoaderModule,
        AssessmentModule,
        UserSearchModule,
        GaugeModule.forRoot()
    ],
    exports: [
        CourseAnalyticsComponent,
        SessionListComponent,
        XAPILogComponent,
        CourseStatsComponent,
        LearnspaceAnalyticsComponent,
        HubStatComponent
    ],
    providers: []
})
export class AnalyticsModule { }
